import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { IVorgang } from '../../models/ApiTypes';
import SesAuswertungFlaechenRili2025 from './ses/SesAuswertungFlaechenRili2025';
import SesAuswertungFlaechenRili2018 from './ses/SesAuswertungFlaechenRili2018';
import SesAuswertungFlaechenRili2014 from './ses/SesAuswertungFlaechenRili2014';
import VorlageErzeugen from '../vorlagen/VorlageErzeugen';
import VorlageUpload from '../vorlagen/VorlageUpload';
import { VorgangStore } from '../../stores/VorgangStore';
import { bind, inject } from '../../utils/decorators';
import ErteilungAngebot from '../vorlagen/ErteilungAngebot';
import Dienstleistungsnachweis from './abrechnung/Dienstleistungsnachweis';
import DienstleistungsnachweisSammelrechnung from './abrechnung/DienstleistungsnachweisSammelrechnung';
import Callout from '../site/Callout';
import SesUebernahmeMesswerte from './ses/SesUebernahmeMesswerte';
import FotoUpload from './FotoUpload';
import VorgangStatus from './VorgangStatus';
import VorlageUebermitteln from './VorlageUebermitteln';
import VorgangAuftragAdresse from './VorgangAuftragAdresse';
import MailVorlage from './MailVorlage';
import { MailVorlageArt } from './MailVorlage';
import * as ApiTypes from '../../models/ApiTypes';

interface IVorlagenBereichProps {
  vorlagenTyp: string;
  vorgang: IVorgang;
  handleDocumentRefresh: () => void;
}

@observer
export default class VorlagenBereich extends React.Component<IVorlagenBereichProps, {}> {

  @observable messwerteVorhanden: boolean;
  @observable abfrageStatus: undefined | 'angefordert' | 'abgeschlossen';

  @inject(VorgangStore) vorgangStore: VorgangStore;

  async componentDidMount() {
    this.setAbfrageStatus('angefordert');
    const { vorgangguid } = this.props.vorgang;
    let messwerteVorhanden = true;
    switch (this.props.vorlagenTyp) {
      case 'ses_stückprüfung_protokoll':
      case 'dakks_ses_stückprüfung_protokoll':
      case 'intern_ses_stückprüfung_protokoll':
      case 'ses_vermessung_kalibrierschein':
      case 'dakks_ses_vermessung_kalibrierschein':
      case 'dakks_ses_vermessung_kalibrierschein_rili_2018':
      case 'dakks_ses_vermessung_kalibrierschein_rili_2018_2025':
      case 'intern_ses_vermessung_kalibrierschein':
        messwerteVorhanden = await (this.vorgangStore.messwerteSesVorhanden(vorgangguid));
        break;
      default:
    }
    this.setMesswerteVorhanden(messwerteVorhanden);
    this.setAbfrageStatus('abgeschlossen');
  }

  @action setMesswerteVorhanden(vorlagenAnzeigen: boolean) {
    this.messwerteVorhanden = vorlagenAnzeigen;
  }

  @bind @action setAbfrageStatus(status: undefined | 'angefordert' | 'abgeschlossen') {
    this.abfrageStatus = status;
  }

  render() {
    if (this.abfrageStatus !== 'abgeschlossen') {
      return <div>lade Messwertdaten...</div>;
    }
    if (!this.messwerteVorhanden) {
      return (
        <Callout bsStyle="danger">
            <p>Der Vorgang kann erst weiter bearbeitet werden wenn Messwerte erfasst wurden.</p>
            <p>Bitte führen Sie dazu die Auswertung der Messwerte durch.</p>
        </Callout>
      );
    }
    const vorlagenTyp = this.props.vorlagenTyp;
    const vorgangguid = this.props.vorgang.vorgangguid;
    const auftragId = this.props.vorgang.anr;
    const handleDocumentRefresh = this.props.handleDocumentRefresh;
    // @TODO: Flexibler gestalten, viel zu überfrachtet und viel zu unübersichtlich
    switch (vorlagenTyp) {
      case 'sep_kalibrierung_protokoll':
        return (
          <div>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp}  onTriggerDocumentRefresh={handleDocumentRefresh} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Protokoll" dokumentTitel="Protokoll Kalibrierung" />
          </div>
        );
      case 'ses_vermessung_protokoll':
        return (
          <div>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp}  onTriggerDocumentRefresh={handleDocumentRefresh} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Protokoll" dokumentTitel="Protokoll Vermessung" />
          </div>
        );
      case 'ses_stückprüfung_protokoll':
        return (
          <div>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp}  onTriggerDocumentRefresh={handleDocumentRefresh} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Protokoll" dokumentTitel="Protokoll Stückprüfung" />
          </div>
        );
      case 'sep_kalibrierung_ergebnisbericht':
        return (
          <div>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp}  onTriggerDocumentRefresh={handleDocumentRefresh} auftragId={this.props.vorgang.anr} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Ergebnisbericht" dokumentTitel="Ergebnisbericht Kalibrierung" />
          </div>
        );
      case 'ses_vermessung_kalibrierschein':
        return (
          <div>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp}  onTriggerDocumentRefresh={handleDocumentRefresh} auftragId={this.props.vorgang.anr} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Kalibrierschein" dokumentTitel="Kalibrierschein Flächen" />
          </div>
        );
      case 'sep_kalibrierung_kalibrierschein':
        return (
          <div>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp}  onTriggerDocumentRefresh={handleDocumentRefresh} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Kalibrierschein" dokumentTitel="Kalibrierschein"/>
          </div>
        );

      // Interne Rückführung SES
      // @todo: Kann nach Komplettumstellung auf DAkkS-Akkreditiv entfernt werden
      case 'intern_ses_stückprüfung_protokoll':
        return (
          <div>
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              titel="Vorläufiges Stückprüfungsprotokoll erzeugen"
              text={'Erzeugt das ausgefüllte vorläufige Stückprüfungsprotokoll mit den oben erfassten Eingabedaten.<br/><br/> \
              Die Vorlage dient primär der Kontrolle, nachträgliche Korrekturen bitte über Anpassungen der Eingabedaten und erneutes Erzeugen einer Vorlage durchführen.'}
            />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Protokoll" dokumentTitel="Protokoll Stückprüfung" />
          </div>
        );
      case 'intern_sep_kalibrierung_kalibrierschein':
        return (
          <div>
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              auftragId={this.props.vorgang.anr}
              titel="Vorläufigen Kalibrierschein erzeugen"
              text={'Erzeugt den ausgefüllten vorläufigen Kalibrierschein mit den oben erfassten Eingabedaten.<br/><br/> \
              Die Vorlage dient primär der Kontrolle, nachträgliche Korrekturen bitte über Anpassungen der Eingabedaten und erneutes Erzeugen einer Vorlage durchführen.'}
            />
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              text="Klicken Sie auf Auswählen oder ziehen Sie den von Ihnen unterschriebenen Kalibrierschein per Drag&Drop auf diese Fläche, um den Upload vorzubereiten."
              dokumentenBezeichnung="Kalibrierschein"
              dokumentTitel="Kalibrierschein SEP" />
          </div>
        );
      case 'intern_ses_vermessung_kalibrierschein':
        return (
          <div>
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              auftragId={this.props.vorgang.anr}
              titel="Vorläufigen Kalibrierschein erzeugen"
              text={'Erzeugt den ausgefüllten vorläufigen Kalibrierschein mit den oben erfassten Eingabedaten.<br/><br/> \
              Die Vorlage dient primär der Kontrolle, nachträgliche Korrekturen bitte über Anpassungen der Eingabedaten und erneutes Erzeugen einer Vorlage durchführen.<br/><br/> \
              <b>In der Vorlage selbst bitte nur Informationen zu Sperrflächen und Referenzpunkt vor dem Hochladen manuell ergänzen.</b>'}
            />
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              text="Klicken Sie auf Auswählen oder ziehen Sie den von Ihnen unterschriebenen Kalibrierschein per Drag&Drop auf diese Fläche, um den Upload vorzubereiten."
              dokumentenBezeichnung="Kalibrierschein"
              dokumentTitel="Kalibrierschein Flächen" />
          </div>
        );

      // DAkkS SES
      case 'dakks_ses_stückprüfung_protokoll':
        return (
          <VorlageUebermitteln
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            auftragId={this.props.vorgang.anr}
            titel="Daten zum Stückprüfungsprotokoll übermitteln"
            text={'Übermittelt die gespeicherten Daten als vorläufiges Stückprüfungsprotokoll an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.'}
            vorgangAbschliessen={true}
          />
        );
      case 'dakks_sep_kalibrierung_kalibrierschein':
      case 'sep_kalibrierung_kalibrierschein_luxemburg':
        return (
          <VorlageUebermitteln
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            auftragId={this.props.vorgang.anr}
            titel="Daten zum Kalibrierschein übermitteln"
            text={'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.'}
            uploadText={'Bitte verwenden Sie dieses Aktenzeichen für das Stückprüfungsprotokoll.'}
            vorgangAbschliessen={true}
          />
        );
      case 'dakks_ses_vermessung_kalibrierschein':
      case 'dakks_ses_vermessung_kalibrierschein_rili_2018':
      case 'dakks_ses_vermessung_kalibrierschein_rili_2018_2025':
        return (
          <VorlageUebermitteln
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            auftragId={this.props.vorgang.anr}
            titel="Daten zum Kalibrierschein übermitteln"
            text={'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.'}
            uploadText={'Bitte verwenden Sie dieses Aktenzeichen für das Stückprüfungsprotokoll.'}
            vorgangAbschliessen={true}
          />
        );
      case 'sep_kalibrierung_extern':
        return (
          <div>
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              dokumentenBezeichnung="Kalibrierschein (Extern)"
              dokumentTitel="Kalibrierschein (Extern)"
              text="Für den Nachweis einer gültigen Kalibrierung können Sie hier einen extern erzeugten Kalibrierschein hochladen (Über \x22Datei auswählen\x22 oder per Drag&Drop)."
            />
          </div>
        );
      case 'ses_auswertung_messwerte':
        return <SesAuswertungFlaechenRili2014 auftragId={this.props.vorgang.anr} vorgangId={vorgangguid} onTriggerDocumentRefresh={handleDocumentRefresh} editable={true}/>;
      // @todo: In Vorlagensystem einbetten!
      case 'ses_auswertung_messwerte_rili_2018':
        return <SesAuswertungFlaechenRili2018 auftragId={this.props.vorgang.anr} vorgangId={vorgangguid} onTriggerDocumentRefresh={handleDocumentRefresh} editable={true}/>;
      case 'ses_auswertung_messwerte_rili_2018_2025':
        return <SesAuswertungFlaechenRili2025 auftragId={this.props.vorgang.anr} vorgangId={vorgangguid} onTriggerDocumentRefresh={handleDocumentRefresh} editable={true}/>;
      case 'ses_uebernahme_messwerte':
        return <SesUebernahmeMesswerte auftragId={this.props.vorgang.anr} vorgangId={vorgangguid} />;
      case 'ses_angebotserstellung':
      case 'sep_angebotserstellung_luxemburg':
        return (
          <div>
            <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
            <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Auftraggeber}/>
            <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp} onTriggerDocumentRefresh={handleDocumentRefresh} zeigeCaption={false} />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Auftragserteilung" dokumentTitel="Auftragserteilung" />
            <ErteilungAngebot auftragId={auftragId} />
          </div>
        );
      case 'ses_auftragsbestaetigung':
        return (
          <div>
            <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
            <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Beauftragter}/>
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              text="Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen."
              zeigeCaption={false}
            />
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              dokumentenBezeichnung="Auftragsbestätigung"
              dokumentTitel="Auftragsbestätigung"
              text="Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Vermessung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)."
            />
          </div>
        );
      case 'sep_auftragsbestaetigung_luxemburg':
        return (
          <div>
            <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
            <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Beauftragter}/>
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              text="Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen."
              zeigeCaption={false}
            />
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              dokumentenBezeichnung="Auftragsbestätigung"
              dokumentTitel="Auftragsbestätigung"
              text="Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Kalibrierung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)."
            />
          </div>
        );
      case 'ses_foto_dokumentation':
      return (
        <div>
          <FotoUpload
            vorgangId={vorgangguid}
            kategorien={['Gerät', 'Fläche', 'Sonstiges']}
          />
          <VorgangStatus
            auftragId={auftragId}
            vorgangId={vorgangguid}
            status="abgeschl"
            caption="Fotodokumentation abschließen"
            text="Markiert die Fotodokumentation des Systems als abgeschlossen, ein Hochladen von weiteren Fotos ist danach nicht mehr möglich."
            buttonCaption="Abschließen"
            bsStyle="success"
          />
        </div>
      );
      // Dienstleistungsnachweis zur Rechnungserstellung
      case 'agt_nachweis_sammel_dienstleistung':
      case 'bps_nachweis_sammel_dienstleistung':
      case 'ses_nachweis_sammel_dienstleistung':
      case 'labor_nachweis_sammel_dienstleistung':
        return (
          <div>
            <DienstleistungsnachweisSammelrechnung vorgangId={vorgangguid} onTriggerDocumentRefresh={handleDocumentRefresh} />
          </div>
        );
      case 'ses_nachweis_dienstleistung':
      case 'sep_nachweis_dienstleistung_luxemburg':
      case 'agt_nachweis_dienstleistung':
      case 'bps_nachweis_dienstleistung':
      case 'labor_nachweis_dienstleistung':
        return (
          <div>
            <Dienstleistungsnachweis vorgangId={vorgangguid} onTriggerDocumentRefresh={handleDocumentRefresh} />
          </div>
        );
      // Kalibrierung Abgasmessgeräte
      case 'agt_4gas_kalibrierschein':
      case 'dakks_agt_4gas_kalibrierschein':
      case 'agt_opazimeter_kalibrierschein':
      case 'dakks_agt_opazimeter_kalibrierschein':
      case 'dakks_agt_partikelzaehler_kalibrierschein':
        return (
          <VorlageUebermitteln
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            auftragId={this.props.vorgang.anr}
            titel="Daten zum Kalibrierschein übermitteln"
            text={'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.'}
            uploadText={'Bitte verwenden Sie dieses Aktenzeichen für das Stückprüfungsprotokoll.'}
            vorgangAbschliessen={true}
          />
        );
      case 'agt_angebotserstellung':
      case 'agt_angebotserstellung_luxemburg':
        return (
          <div>
            <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
            <VorgangAuftragAdresse
              adressArt={ApiTypes.AdressArt.Auftraggeber}
            />
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              titel="Angebotsvorlage erzeugen"
              text="Erzeugt eine vorausgefüllte Angebotsvorlage für die Vor-Ort Kalibrierung eines Abgasmessgerätes inkl. Auftragserteilung."
              zeigeCaption={false}
            />
            <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Auftragserteilung" dokumentTitel="Auftragserteilung" />
            <ErteilungAngebot auftragId={auftragId} />
          </div>
        );
      case 'agt_auftragsbestaetigung':
        return (
          <div>
            <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
            <VorgangAuftragAdresse
              adressArt={ApiTypes.AdressArt.Beauftragter}
            />
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              text="Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen."
              zeigeCaption={false}
            />
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              dokumentenBezeichnung="Auftragsbestätigung"
              dokumentTitel="Auftragsbestätigung"
              text="Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Vermessung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)."
            />
          </div>
        );
      case 'agt_foto_dokumentation':
        return (
          <div>
            <FotoUpload
              vorgangId={vorgangguid}
              kategorien={['Gerät', 'Typschild', 'Sonstiges']}
            />
            <VorgangStatus
              auftragId={auftragId}
              vorgangId={vorgangguid}
              status="abgeschl"
              caption="Fotodokumentation abschließen"
              text="Markiert die Fotodokumentation des Gerätes als abgeschlossen, ein Hochladen von weiteren Fotos ist danach nicht mehr möglich."
              buttonCaption="Abschließen"
              bsStyle="success"
            />
          </div>
        );
      // Kalibrierung Bremsenprüfstände (DAkkS)
      case 'bps_referenzkraft_kalibrierschein':
      case 'bps_referenzkraft_kalibrierschein_rili_2021':
      case 'bps_referenzkraft_kalibrierschein_platte_rili_2021':
          return (
          <VorlageUebermitteln
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            auftragId={this.props.vorgang.anr}
            titel="Daten zum Kalibrierschein übermitteln"
            text={'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.'}
            vorgangAbschliessen={true}
          />
        );
      // Kalibrierung Druckmessgeräte (DMG)
      case 'dmg_handpumpe_kalibrierschein':
        return (
          <VorlageUebermitteln
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            auftragId={this.props.vorgang.anr}
            titel="Daten zum Kalibrierschein übermitteln"
            text={'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.'}
            vorgangAbschliessen={true}
          />
        );
     // Angebot Bremsprüfstand
     case 'bps_angebotserstellung':
     case 'bps_angebotserstellung_luxemburg':
      return (
        <div>
          <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
          <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Auftraggeber}/>
          <VorlageErzeugen vorgangId={vorgangguid} vorlage={vorlagenTyp} onTriggerDocumentRefresh={handleDocumentRefresh} zeigeCaption={false} />
          <VorlageUpload vorgangId={vorgangguid} vorlage={vorlagenTyp} dokumentenBezeichnung="Auftragserteilung" dokumentTitel="Auftragserteilung" />
          <ErteilungAngebot auftragId={auftragId} />
        </div>
      );
    case 'bps_auftragsbestaetigung':
      return (
        <div>
          <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
          <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Beauftragter}/>
          <VorlageErzeugen
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            text="Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen."
            zeigeCaption={false}
          />
          <VorlageUpload
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            dokumentenBezeichnung="Auftragsbestätigung"
            dokumentTitel="Auftragsbestätigung"
            text="Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Vermessung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)."
          />
        </div>
      );
    // Allgemeine Kalibrierung
    case 'kal_auftragsbestätigung':
      return (
        <div>
          <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
          <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Auftraggeber}/>
          <MailVorlage
              caption="Versand der Auftragsbestätigung"
              text="Erzeugt eine vorausgefüllte Mailvorlage zum Versand der Auftragsbestägigung an den Auftraggeber."
              vorlage={MailVorlageArt.Auftragsbestätigung}
            />
          <VorlageErzeugen
            vorgangId={vorgangguid}
            vorlage={vorlagenTyp}
            onTriggerDocumentRefresh={handleDocumentRefresh}
            text="Erzeugt eine vorausgefüllte Vorlage im Word-Format.\ Diese kann vor der Übermittlung an den Kunden oder Auftraggeber angepasst werden."
            zeigeCaption={false}
          />
        </div>
      );
      case 'kal_lieferschein':
        return (
          <div>
            <h3><a name="#dokumente"/>Dokumente erzeugen</h3>
            <VorgangAuftragAdresse adressArt={ApiTypes.AdressArt.Lieferadresse}/>
            <VorlageErzeugen
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              onTriggerDocumentRefresh={handleDocumentRefresh}
              text="Erzeugt eine vorausgefüllte Vorlage im Word-Format.\ Diese kann vor der Übermittlung an den Kunden oder Auftraggeber angepasst werden."
              zeigeCaption={false}
            />
          </div>
        );
      // Freier Upload Anzahl beliebiger Dokumente, z.B. für interne Workflows
      case 'dokumenten_upload':
        return (
          <div>
            <VorlageUpload
              vorgangId={vorgangguid}
              vorlage={vorlagenTyp}
              text={'Klicken Sie auf \"Datei auswählen\" oder ziehen Sie das hochzuladende Dokument per Drag&Drop auf diese Fläche.'}
              dokumentenBezeichnung="Dokument"
              abschliessen={false}
            />
          </div>
        );
      default:
        return <div />;
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorlagenBereich.tsx